var map = {
	"./1/2.jpg": 9057,
	"./2/2.jpg": 9597,
	"./3/2.jpg": 3718,
	"./4/2.jpg": 3929,
	"./5/2.jpg": 1153,
	"./6/2.jpg": 1820,
	"./7/2.jpg": 4192,
	"./8/2.jpg": 5080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6338;